import API from ".";

export const generateOrginationEwiByState = async (filters: any) => {
  try {
    const fromDate = filters.fromDate ?? "";
    const toDate = filters.toDate ?? "";
    const period = filters.period ?? "";
    const state = filters.state ?? "";
    const territory = filters.territory ?? "";
    const cluster = filters.cluster ?? "";
    const branch = filters.branch ?? "";

    const response = await API.get(`generate/new_origination_summary/list_origination_ewi_by_state?from_date=${fromDate}&to_date=${toDate}&group_by=${period}&state_id=${state}&territory_id=${territory}&cluster_id=${cluster}&branch_id=${branch}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

export const generateOrginationEmiByState = async (filters: any) => {
  try {
    const fromDate = filters.fromDate ?? "";
    const state = filters.state ?? "";
    const territory = filters.territory ?? "";
    const cluster = filters.cluster ?? "";
    const branch = filters.branch ?? "";
    const toDate = filters.toDate ?? "";
    const period = filters.period ?? "";

    const response = await API.get(`/generate/new_origination_summary/list_origination_emi_by_state?from_date=${fromDate}&to_date=${toDate}&group_by=${period}&state_id=${state}&territory_id=${territory}&cluster_id=${cluster}&branch_id=${branch}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};